module.exports = __webpack_public_path__ + "assets/media/link-copied.d1e9a353.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/link-copied.svg
// module id = 307
// module chunks = 0